import * as React from 'react';
import {Stack, Snackbar} from '@mui/material';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { setSnackbar } from './slice';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref,
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const CustomizedSnackbars = ()=> {

  const dispatch = useAppDispatch();
  const selector = useAppSelector(state=>state.snackbar.value);

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    dispatch(setSnackbar({open: false}));
  };

  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar open={selector.open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{vertical:'top', horizontal:'right'}}>
        <Alert onClose={handleClose} severity={selector.severity} sx={{ width: '100%' }}>
          {selector.message}
        </Alert>
      </Snackbar>
    </Stack>
  );
}


export default CustomizedSnackbars;